/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WitsmlTypeDto
 */
export interface WitsmlTypeDto {
    /**
     * 
     * @type {string}
     * @memberof WitsmlTypeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WitsmlTypeDto
     */
    name?: string;
}

/**
 * Check if a given object implements the WitsmlTypeDto interface.
 */
export function instanceOfWitsmlTypeDto(value: object): value is WitsmlTypeDto {
    return true;
}

export function WitsmlTypeDtoFromJSON(json: any): WitsmlTypeDto {
    return WitsmlTypeDtoFromJSONTyped(json, false);
}

export function WitsmlTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WitsmlTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function WitsmlTypeDtoToJSON(value?: WitsmlTypeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

